import { useEffect, useState } from "react";
import DayJS from 'react-dayjs';
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import setDate from "date-fns/set";
import StyledCard from 'components/StyledCard';
import useAuth from "../../hooks/useAuth";
import useUser from "../../hooks/useUser";
import useAPI from "../../hooks/useAPI";
import useDb from "../../hooks/useDb";
import PageLayout from "components/PageLayout";
import { useHistory } from "react-router-dom";
import useStyles from './styles';

const Dashboard = () => {
  const history = useHistory();
  const [appointments, setAppointments] = useState([]);
  const { user } = useUser();
  const api = useAPI();
  const db = useDb();
  const styles = useStyles()

  useEffect(() => {
    api
      .get(`/technicians/${user?._id}/appointments`, {
        params: {
          start: setDate(new Date(), {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          })
        },
      })
      .then(async (res) => {
        // deletes appointments not in http response
        let appointmentsInResponse = []
        res.data.appointments.map(appt => appointmentsInResponse.push(appt?._id));
        console.log('TESTING --------------------------------')
        await db.table("appointments").toArray()
          .then(apptArray => {
            // console.log({apptArray})
            console.log('test function 1')
            console.log({appointmentsInResponse, apptArray})
            apptArray.map(async existingAppointment => {
              if (appointmentsInResponse.includes(existingAppointment?._id) && existingAppointment?.completed === false) return
              else await db.appointments
                .where({ _id: existingAppointment?._id })
                .delete()
            })
          })
          .catch((err) => {
            alert(err.message)
          })

        // attempt to handle empty array when there are no open appointments
        // assigned to current tech. should delete all cached appointments

        res.data.appointments.map(async (appt) => {
          console.log('test function 2')
          const apptId = appt?._id

          // currently working, updates start and end times on active appointments
          await db.appointments
            .where({ _id: apptId })
            .modify({
              start: appt.start,
              end: appt.end,
              technician: appt?.technician
            })
        })

        await db.appointments.bulkAdd(
          res.data.appointments.map((appt) => ({ ...appt, pictures: [] }))
        );
        
        // deletes appointments not assigned to tech
        res.data.appointments.map(async (appt) => {
          console.log('test function 3')
          await db.appointments
            .get({ _id: appt?._id })
            .then(async _appointment => {
              console.log(_appointment)
              if (_appointment?.technician?._id !== user?._id) {
                await db.appointments
                  .where({ _id: _appointment?._id })
                  .delete()
              }
              if (appt.status === 'closed') {
                await db.appointments
                  .where({ _id: appt?._id })
                  .delete()
              }
            })
        })

        // console.log(currentAppointments)
        // res.data.appointments.map(async (appt) => {
        //   const apptId = appt?._id
        //   await db.appointments
        //     .get({ _id: apptId })
        //     .then(async appointment => {
        //       console.log(appointment?._id, apptId)
        //       if (!appointment) return
        //       if (appt?.technician?._id !== appointment?.technician?._id) {
        //         await db.appointments
        //           .where({ _id: appointment?._id })
        //           .delete()
        //       }
        //     })
        // })
      })
      .catch((err) => {
        if (err.name === "BulkError") {
          console.log("ignore dupe keys");
        } else {
          console.log(err);
        }
      })
      .finally(async () => {
        const _appointments = await db.appointments
          .filter((appt) => !appt.completed && appt?.technician?._id === user?._id)
          .toArray();
        setAppointments(_appointments);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {

    }
  }, []);

  const jumpToAppointment = (appointment) => {
    history.push(`/appointment/${appointment?._id}`)
  }

  const refreshPage = () => {
    window.location.reload();
  }

  return (
    <PageLayout title="Dashboard">
      <Container maxWidth="md">
        <h1 className={styles.heading}>Welcome, {user.firstName}!</h1>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h5" component="h3" className={styles.myAppointments}>My Appointments</Typography>
          <Button variant="contained" color="primary" onClick={refreshPage}>
            Refresh
          </Button>
        </Box>
        {appointments.map((appt) => (
          <StyledCard variant="outlined" key={appt?._id}>
            <Box display="flex">
              <Box flex={1}>
                <Typography variant="h6" className={styles.subheading}>Customer Information:</Typography>
                <Typography className={styles.paragraph}>{`${appt.customer.firstName} ${appt.customer.middleName ? appt.customer.middleName : ''} ${appt.customer.lastName}`}</Typography>
                <Typography className={styles.paragraph}>{`${appt.customer.streetNumber} ${appt.customer.streetName}`} {appt.customer.unit ? `UNIT ${appt.customer.unit}` : ''}</Typography>
                <Typography className={styles.paragraph}>{`${appt.customer.city}, ${appt.customer.primaryPhone}`}</Typography>
                <Typography className={styles.paragraph}>Enrollment #: { appt.customer.enrollment?.enrollmentNumber }</Typography>
                <Typography className={styles.paragraph}>CLIMATE ZONE: {appt.customer.climateZone}</Typography>
                <Typography className={styles.paragraph}>OCCUPANCY STATUS: {appt.customer.occupancyStatus}</Typography>
              </Box>
              <Box flex={1}>
                <Typography variant="h6" className={styles.subheading}>Time and Date:</Typography>
                <Typography className={styles.paragraph}><DayJS format="MM/DD/YYYY">{ appt.start }</DayJS></Typography>
                <Typography className={styles.paragraph}><DayJS format="hh:mm a">{ appt.start }</DayJS> - <DayJS format="hh:mm a">{ appt.end }</DayJS></Typography>
              </Box>
            </Box>
            <Button className={styles.viewButton} variant="contained" color="primary" onClick={() => jumpToAppointment(appt)}>
              View
            </Button>
          </StyledCard>
        ))}
      </Container>
    </PageLayout>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();
  return (
    <PrivateContent title="Dashboard">
      <Dashboard />
    </PrivateContent>
  );
};

export default Page;
